import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';

interface CreateInvoiceModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CreateInvoiceModal = ({ open, onOpenChange }: CreateInvoiceModalProps) => {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="sm:max-w-[600px] bg-white">
        <DialogHeader>
          <DialogTitle>
            Create Invoice
          </DialogTitle>
        </DialogHeader>

        <div className="py-4">
          <p className="text-gray-500 text-center">
            Invoice creation functionality coming soon!
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};